import {
  DefaultButton,
  Panel,
  PanelType,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  TextField,
} from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CreateSubjectAreaPanel = ({
  isOpen,
  onClose,
  subjectAreaTitle,
  setSubjectAreaTitle,
  onConfirmCreateSubjectArea,
  isCreatingSubjectArea,
}) => {
  const { t: translator } = useTranslation();
  const onTextChange = (_, value) => setSubjectAreaTitle(value);

  return (
    <div>
      <Panel
        isOpen={isOpen}
        type={PanelType.medium}
        onDismiss={isCreatingSubjectArea || onClose}
        isLightDismiss={true}
        onOuterClick={() => {}}
        closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      >
        <div>
          <div className="panel-content">
            <h3 className="panel-header">
              {translator('pages.adminSubjectAreas.addSubjectArea')}
            </h3>
            <TextField
              label={translator('pages.adminSubjectAreas.panelGuideText')}
              value={subjectAreaTitle}
              onChange={onTextChange}
              placeholder={translator(
                'pages.adminSubjectAreas.panelPlaceholder',
              )}
            />
          </div>
          <div className="panel-buttons">
            {isCreatingSubjectArea && <Spinner size={SpinnerSize.large} />}
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onClose}
              disabled={isCreatingSubjectArea}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirmCreateSubjectArea}
              disabled={isCreatingSubjectArea}
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

export { CreateSubjectAreaPanel };
